import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "../../components/Icon/Icon";
import { Txt } from "../../components/Txt/Txt";
import Checkmark from "../../icons/checkmark.svg";
import Information from "../../icons/information.svg";
import styles from "./Info.module.scss";
export const Info = ({ variant = "info", message, className = "", dataTestId = "", iconWitdh = "14px", iconHeight = "14px", iconClassName = "", textClassName, }) => {
    const iconComponent = {
        checkmark: Checkmark,
        error: Information,
        info: Information,
    };
    return (_jsxs(Txt, { className: `${styles.infoSupp} ${variant === "error" ? styles.error : ""} ${variant === "checkmark" ? styles.checkmark : ""} ${className}`, dataTestId: dataTestId, children: [variant && (_jsx(Icon, { component: iconComponent[variant], className: `${styles.icon} ${iconClassName}`, width: iconWitdh, height: iconHeight })), _jsx("span", { className: textClassName, children: message })] }));
};
//# sourceMappingURL=Info.js.map